export class LoyaltyCatalogCategoryGift {
    id: number;
    code: string;
    progres: number;
    description: string;
}


// WEBPACK FOOTER //
// ./src/app/models/loyalty-catalog-category-gift.ts